import {load as loadAuth} from './auth';
import {load as loadSplash} from './splash';
import {load as loadStaff} from './staff';
import {load as loadSupportWorker} from './supportWorker';

export const load = (app) => {
	loadAuth(app);
	loadSplash(app);
	loadStaff(app);
	loadSupportWorker(app);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/loader.js